import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../../axios";
import { errorToast, successToast } from "../../../utils/toast";
import { FiMail, FiPhone, FiTrash2, FiUsers } from "react-icons/fi";
import { MdGTranslate, MdOutlineVerified } from "react-icons/md";
import { FaAngleLeft } from "react-icons/fa";

const Security = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { data } = await axios.get("me");
        setUser(data?.result || null);
      } catch (error) {
        console.error("Failed to load security details:", error);
        errorToast(error?.response?.data?.message || "Failed to load security details");
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const handleDeleteAccount = async () => {
    try {
      setDeleting(true);
      await axios.delete("/users/me");
      successToast("Account deleted successfully");
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      window.location.href = "/login";
    } catch (error) {
      console.error("Failed to delete account:", error);
      errorToast(error?.response?.data?.message || "Failed to delete account");
    } finally {
      setDeleting(false);
      setShowDeleteConfirm(false);
    }
  };

  const mobileText = user?.mobile || "Not added";
  const isMobileVerified = Boolean(user?.mobile);

  const securityRows = [
    {
      label: "Mobile Number",
      value: mobileText,
      icon: <FiPhone className="h-5 w-5 text-[#5B2A6D]" />,
    },
    {
      label: "Email Address",
      value: user?.email || "Not added",
      icon: <FiMail className="h-5 w-5 text-[#5B2A6D]" />,
    },
    {
      label: "Mobile Verification",
      value: isMobileVerified ? "Verified" : "Not verified",
      icon: <MdOutlineVerified className="h-5 w-5 text-[#5B2A6D]" />,
    },
    {
      label: "User ID",
      value: user?._id || user?.id || "Not available",
      icon: <FiUsers className="h-5 w-5 text-[#5B2A6D]" />,
    },
    {
      label: "Language",
      value: user?.language || user?.preferredLanguage || "en",
      icon: <MdGTranslate className="h-5 w-5 text-[#5B2A6D]" />,
    },
  ];

  return (
    <div className="min-h-screen bg-[#F7F4FB] px-5 py-1 lg:py-12 text-slate-900 sm:px-6">
      <div className="mx-auto max-w-2xl">
        <div className="mb-2 flex items-center mt-4 gap-6">
                 <button
                   type="button"
                   onClick={() => navigate(-1)}
                   className="flex h-10 w-10 items-center justify-center rounded-full bg-white/60"
                 >
                   <FaAngleLeft className="h-7 w-7 text-black" />
                 </button>
                 <h1 className="text-2xl font-bold text-black">Security</h1>
               </div>

        {loading ? (
          <div className="flex min-h-[50vh] items-center justify-center">
            <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#4B1D67] border-t-transparent" />
          </div>
        ) : (
          <>
            <section className="rounded-[26px] bg-white items-start text-left px-6 py-2 shadow-sm">
              <h2 className="text-lg font-bold text-[#191422]">
                Account Security
              </h2>
              <p className=" break-all text-md font-medium text-[#6F6879]">
                {mobileText} {isMobileVerified ? "verified" : "not verified"}
              </p>
            </section>

            <section className="mt-4 rounded-[26px] bg-white px-6 py-4 shadow-sm">
              <div className="space-y-4">
                {securityRows.map((item) => (
                  <div key={item.label} className="flex items-start gap-6">
                    <div className="flex h-[35px] w-[35px] shrink-0 items-center justify-center rounded-2xl bg-[#F1E8F9]">
                      {item.icon}
                    </div>
                    <div className="min-w-0">
                      <h3 className="text-[16px] font-extrabold leading-tight items-start text-left text-[#191422]">
                        {item.label}
                      </h3>
                      <p className="mt-1 break-all text-md font-medium items-start text-left text-[#6F6879]">
                        {item.value}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </section>
{/* 
            <section className="mt-2 rounded-[26px] border border-red-100 bg-white px-8 py-4 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="flex h-[35px] w-[35px] shrink-0 items-center justify-center rounded-2xl bg-red-50">
                  <FiTrash2 className="h-5 w-5 text-red-600" />
                </div>
                <div className="itms-start text-left">
                  <h2 className="text-md font-semibold text-[#191422]">
                    Delete Account
                  </h2>
                  <p className="mt-1 text-sm font-medium leading-5 text-[#6F6879]">
                    Permanently remove your account and sign out of this device.
                  </p>
                </div>
              </div>

              <button
                type="button"
                disabled
                className="mt-4 flex w-full cursor-not-allowed items-center justify-center rounded-2xl bg-red-600 px-2 py-2 text-xl font-bold text-white opacity-50 shadow-sm"
              >
                Delete My Account
              </button>
            </section> */}
          </>
        )}
      </div>

      {showDeleteConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-5">
          <div className="w-full max-w-md rounded-[28px] bg-white p-6 text-left shadow-xl">
            <div className="flex items-start gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-red-50">
                <FiTrash2 className="h-6 w-6 text-red-600" />
              </div>
              <div>
                <h2 className="text-xl font-extrabold text-[#191422]">
                  Are you sure?
                </h2>
                <p className="mt-2 text-sm font-medium leading-6 text-[#6F6879]">
                  Are you sure you want to delete your account? This action cannot be undone.
                </p>
              </div>
            </div>

            <div className="mt-6 grid grid-cols-2 gap-3">
              <button
                type="button"
                onClick={() => setShowDeleteConfirm(false)}
                disabled={deleting}
                className="rounded-2xl border border-[#D8D1DE] px-4 py-3 text-base font-bold text-[#191422] disabled:cursor-not-allowed disabled:opacity-70"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleDeleteAccount}
                disabled={deleting}
                className="rounded-2xl bg-red-600 px-4 py-2 text-md text-base font-bold text-white disabled:cursor-not-allowed disabled:opacity-70"
              >
                {deleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Security;
